if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', class BackInStock extends HTMLElement {
    constructor() {
      super();
      if (!this.hasAttribute('available')) return;

      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=back-in-stock`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderForm(sectionInnerHTML);
        })
        .catch(e => {
          this.renderError();
        });
    }

    renderForm(sectionInnerHTML) {
      if (!sectionInnerHTML.querySelector('back-in-stock-form')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('back-in-stock-form').outerHTML;
      this.setAttribute('available', '');
    }

    renderError() {
      this.innerHTML = '';
    }
  });
}


if (!customElements.get('back-in-stock-form')) {
  customElements.define('back-in-stock-form', class BackInStockForm extends HTMLElement {
    constructor() {
      super();
      this.inputEmail = this.querySelector('input[name="email"]');
      this.submitButton = this.querySelector('button[type="button"]');
      this.alertError = this.querySelector('#BackInStockError');
      this.inputEmail.addEventListener('change', this.onInputChange.bind(this));

      const debouncedOnSubmit = debounce((event) => {
        this.onSubmit(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);

      this.submitButton.addEventListener("click", debouncedOnSubmit.bind(this));

      //this.alreadyRegistered()
    }

    alreadyRegistered() {
      const formData = new FormData();
      formData.append('email', this.inputEmail.value);
      formData.append('variant', this.getAttribute('variant'));
      formData.append('format', 'json');

      fetch(`${Shopify.app.url}/customer/has-subscribed-back-in-stock`, {
        method: "POST",
        headers: {
          'X-Bigkids-Auth-Token': Shopify.app.token,
          'X-Bigkids-Shop': Shopify.shop
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          console.log(response)
        });
    }

    validateEmail() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.inputEmail.value).toLowerCase());
    }

    onInputChange(event) {
      if (this.validateEmail()) this.alertError.classList.add('hidden');
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.validateEmail()) {
        this.alertError.classList.remove('hidden');
        return;
      }
      this.alertError.classList.add('hidden');
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

      const formData = new FormData();
      formData.append('email', this.inputEmail.value);
      formData.append('variant', this.dataset.variantId);
      formData.append('format', 'json');

      fetch(`${Shopify.app.url}/customer/subscribe-back-in-stock`, {
        method: "POST",
        headers: {
          'X-Bigkids-Auth-Token': Shopify.app.token,
          'X-Bigkids-Shop': Shopify.shop
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('.loading__spinner').classList.add('hidden');

          if (response.status === true) {
            this.submitButton.classList.add('button--subscribed');
            this.submitButton.querySelector('span').innerHTML = 'Ok. On fait au plus vite.';

            this.inputEmail.setAttribute('disabled', true);
            this.inputEmail.setAttribute('aria-disabled', true);
            this.inputEmail.closest('.field').classList.add('field__valid');
            return;

          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
            Toast(response.error || Theme.translations.notification.error || 'Une erreur est survenue.', 'error');
          }

          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        })
        .catch(e => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          Toast(Theme.translations.notification.error || 'Une erreur est survenue.', 'error');
        });;
    }
  });
}